<template>
  <b-modal sticky-header ref="showLogsModal" hide-footer centered title="User Data Change Logs" size="xl">
    <div>
      <b-table  striped hover :fields= "[
          { key: 'date', sortable: true },
          { key: 'userEmail', sortable: true },
          { key: 'grid', sortable: true }
          ,
          { key: 'oldValue' }
          ,
          { key: 'newValue' }
        ]"
         :items="logs"></b-table>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
// source
import db from "@/services/db";

let $ = window.$;

export default {
  props: ["eventBus"],
  data() {
    return {
      logs: []
    };
  },
  methods: {},
  async created() {
    this.eventBus.$on("showLogsModal", async () => {
      let logs = [];

      let logRef = await db.getRef("dataGridLogs").once("value");

      let rawLogs = Object.values(logRef.val());

      for (let i = 0; i < rawLogs.length; ++i) {
        let log = {
          date: moment(rawLogs[i].date|| null).format('DD-MM-YYYY HH:mm') ,
          grid: rawLogs[i].gridId,
          //userId: rawLogs[i].userId|| null,
          userEmail: rawLogs[i].userEmail|| null,
          type: rawLogs[i].userId|| null,
          oldValue: rawLogs[i].oldVal|| null,
          newValue: rawLogs[i].newVal|| null
        };
        logs.push(log);
      }
      this.logs = logs

      if (this.$refs.showLogsModal) this.$refs.showLogsModal.show();
    });
  },
  mounted() {
    console.log("logs mounted");
    if (this.$refs.showLogsModal) {
      $(this.$refs.showLogsModal["$el"]).appendTo("body");
    }
    this.$on('bv::modal::show', (bvEvent, modalId) => {
      console.log('Modal is about to be shown', bvEvent, modalId)
    })

  },
  beforeDestroy() {
    if (this.$refs.showLogsModal) {
      $(this.$refs.showLogsModal["$el"]).remove();
    }
  }
};
</script>
